var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"pa-2",staticStyle:{"z-index":"6"},attrs:{"padless":"","fixed":""}},[_c('v-spacer'),_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("© Panel Depot / Developed by "),_c('a',{attrs:{"href":"https://vizer.tech"}},[_vm._v("VIZER")])]),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }